import {
  BankingProductMovementsApiResponse,
  BankingProductMovementsParams,
} from '@repo/accounts-types'
import { ApiResponse, Service } from '@repo/core'
import { BankingProductType, LEGACY_CARD_PRODUCT_TYPE } from '@repo/shared-types'
import { AxiosRequestConfig } from 'axios'

const productTypeUrlMap: Partial<
  Record<BankingProductType | typeof LEGACY_CARD_PRODUCT_TYPE, string>
> = {
  CASH: 'cash-accounts',
  DEPOSIT: 'deposits',
  CREDIT: 'credits',
  CREDIT_CARD: 'credit-cards',
  DEBIT_CARD: 'debit-cards',
  [LEGACY_CARD_PRODUCT_TYPE]: 'cards',
  LOAN: 'loans',
  INVESTMENT: 'investments',
}

export const getBankingProductMovements: Service<
  BankingProductMovementsParams,
  ApiResponse<BankingProductMovementsApiResponse>,
  Pick<AxiosRequestConfig, 'signal'>
> = async ({ api, params, accept, config }) => {
  const { productType, id, dateFrom, dateTo } = params

  return api.get<ApiResponse<BankingProductMovementsApiResponse>>(
    `/accounts/${productTypeUrlMap[productType]}/${id}/movements`,
    {
      params: { dateFrom, dateTo },
      ...config,
      ...(accept && { headers: { Accept: accept }, responseType: 'blob' as const }),
    },
  )
}
